import ApiService from "@/utils/request";

export const calculatorServe = {
  all_enum(params = {}) {
    return ApiService.query("/dg_admin/v2/dict/all_enum/", {});
  },
  industry(params = {}) {
    return ApiService.query("/policy/v2/industry/", {});
  },
  fit_object(params = {}) {
    return ApiService.query("/policy/v2/fit_object/", {});
  },
  mof_div(params = {}) {
    return ApiService.query("/policy/v2/inner/mof_div/", {});
  },
  money(params = {}) {
    return ApiService.query("/policy/v2/inner/calculation/money/", {
      page: 1,
      size: 100,
      ...params,
    });
  },
  calculation(params = {}) {
    return ApiService.query("/policy/v2/inner/calculation/", {
      page: 1,
      size: 100,
      ...params,
    });
  },
  getUnit(params) {
    return ApiService.query("/policy/v2/inner/calculation/get_unit/", params);
  },
};
